<template>
  <div class="log-container">
    <el-card shadow="hover">
      <div class="filter-bar" style="margin-bottom: 10px;">
        <el-select
          v-model="serviceFilter"
          placeholder="选择服务"
          clearable
          @change="fetchLogs"
          style="width: 200px">
          <el-option
            v-for="service in serviceList"
       :key="service"
            :label="service"
            :value="service">
          </el-option>
        </el-select>

        <el-select
          v-model="logLevel"
          placeholder="选择日志等级"
          clearable
          @change="fetchLogs"
          style="width: 120px; margin-left: 15px">
          <el-option
            v-for="level in levelOptions"
        :key="level.value"
            :label="level.label"
            :value="level.value">
          </el-option>
        </el-select>
      </div>

      <el-table 
        :data="logData" 
        border 
        stripe 
        v-loading="loading"
        style="width: 100%; min-width: 1200px">
        
        <el-table-column 
          prop="id" 
          label="ID" 
          width="70"
          sortable>
        </el-table-column>

        <el-table-column prop="log_type" label="日志类型">
          <template #default="{row}">
            <!-- :type="logTypeTag(row.log_type)" -->
            <el-tag >
              {{ logTypeCN[row.log_type] || row.log_type }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column prop="service_name" label="服务名称" >
    <template #default="{row}">
      {{ serviceCN[row.service_name] || row.service_name }}
    </template>
  </el-table-column>

        <el-table-column prop="trace_id" label="追踪ID" >
          <template #default="{row}">
            <el-link type="primary" @click="viewTrace(row.trace_id)">
              <!-- {{ row.trace_id }} -->
                
            </el-link>
          </template>
        </el-table-column>
<!--   :color="severityColor(row.severity)" -->
        <el-table-column prop="severity" label="严重程度">
          <template #default="{row}">
            <el-progress 
              :percentage="row.severity * 33" 
            
              :show-text="false">
            </el-progress>
          </template>
        </el-table-column>

        <el-table-column prop="log_time" label="时间"  sortable>
          <template #default="{row}">
            <!-- {{ formatTime(row.log_time) }} -->
              {{ row.log_time }}
          </template>
        </el-table-column>

        <!-- <el-table-column label="操作" width="120">
          <template #default="{row}">
            <el-button 
              size="mini" 
              type="primary" 
              @click="showDetail(row)">
              详情
            </el-button>
          </template>
        </el-table-column> -->
      </el-table>

      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        background :current-page="currentPage"
        :page-sizes="[20, 100,500, 1000]"
        layout="total,sizes, prev, pager, next, jumper"
        :total="totalDataNumber"></el-pagination>
    </el-card>

    <!-- <log-detail-dialog 
      :visible="detailVisible"
      :detailData="currentDetail"
      @close="detailVisible = false">
    </log-detail-dialog> -->
  </div>
</template>

<script>
import LogApi from '@/api/log.js';
export default {
  data() {
    return {
      logData: [],
      serviceList: ['payment-service', 'user-service', 'order-service', 'api-gateway'],
      serviceFilter: '',
      logLevel: '',
      levelOptions: [
        { value: 0, label: 'INFO' },
        { value: 1, label: 'WARNING' },
        { value: 2, label: 'ERROR' }
      ],
      currentPage: 1,
      pageSize: 20,
      totalDataNumber: 0,
      // ...其他data属性与安全日志页面类似
      // 日志类型中英对照
      logTypeCN: {
        'ERROR': '错误',
        'WARNING': '警告',
        'INFO': '信息',
        'DEBUG': '调试',
        'CRITICAL': '严重'
      },

      // 服务名称对照
      serviceCN: {
        'payment-service': '支付服务',
        'user-service': '用户服务',
        'order-service': '订单服务',
        'api-gateway': 'API网关',
        'cron-job': '定时任务'
      }
    }
  },
  created() {

    this.fetchLogs();
  },
  methods: {
     /*选择第几页*/
     handleCurrentChange(val) {
      this.currentPage = val
      this.getTableList()
    },
    /*每页多少条*/
    handleSizeChange(val) {
      this.currentPage = 1
      this.pageSize = val
      this.getTableList()
    },
     fetchLogs() {
      var self = this;
      this.loading = true
      try {
        const params = {
          page: this.currentPage,
          size: this.pageSize,
          service: this.serviceFilter,
          level: this.logLevel
        }

        LogApi.getSystemLog(params, true)
        .then(data => {
          self.loading = false;
          self.logData =data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {});
      } finally {
        this.loading = false
      }
    },
    // ...其他方法
  }
}
</script>



// WEBPACK FOOTER //
// src/views/auth/systemlog/index.vue